import type { CourseDraftDetailResponseInstructor } from './courseDraftDetailResponseInstructor';
import type { CourseDraftDetailResponseLevel } from './courseDraftDetailResponseLevel';
import type { CourseDraftDetailResponsePrice } from './courseDraftDetailResponsePrice';
import type { CourseDraftDetailResponseSectionsItem } from './courseDraftDetailResponseSectionsItem';

/**
 * 강의 초안 상세 정보 응답
 */
export interface CourseDraftDetailResponse {
  createdAt?: string;
  /** @nullable */
  description?: string | null;
  /** 강의 초안 ID */
  id: number;
  /** 기본 사용자 정보 */
  instructor?: CourseDraftDetailResponseInstructor;
  /** 발행 여부 (초안이므로 항상 false) */
  readonly isPublished?: boolean;
  /** @nullable */
  level?: CourseDraftDetailResponseLevel;
  /** @nullable */
  price?: CourseDraftDetailResponsePrice;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: CourseDraftDetailResponseSectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
}
